import { Immutable } from "immer";
import React from "react";

import type { QuestionAnswerList as Value } from "@reactivated";

type IProps = Immutable<{
    value: Value;
}>;

/**
 * Faithful JSX transcription of the legacy sealy
 * ``components/qna/shopping_qna.html`` (#33285).
 */
export const QuestionAnswerList = (props: IProps): React.JSX.Element => {
    return (
        <section className="shopping-questions">
            <div className="shopping-questions__container">
                <h3>{props.value.title}</h3>
                {(props.value.qa_list ?? []).map((qa, index) => (
                    <div className="shopping-questions__qa" key={index}>
                        <h5 className="shopping-questions__question">
                            {qa.question}
                        </h5>
                        <p className="shopping-questions__answer">
                            {qa.answer}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    );
};
